var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRealtimePipelines = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.5 3.5A1.5 1.5 0 0 0 4 5v1.474a1.5 1.5 0 0 0 1.5 1.5h1.095V17.3a1.5 1.5 0 0 0 1.5 1.5h4.852v.2a1.5 1.5 0 0 0 1.5 1.5h4.05a1.5 1.5 0 0 0 1.5-1.5v-1.474a1.5 1.5 0 0 0-1.5-1.5h-4.05a1.5 1.5 0 0 0-1.5 1.5v.074H8.095a.3.3 0 0 1-.3-.3v-4.7h5.075a1 1 0 0 0 .077-.005v.142a1.5 1.5 0 0 0 1.5 1.5h4.05a1.5 1.5 0 0 0 1.5-1.5v-1.474a1.5 1.5 0 0 0-1.5-1.5h-4.05a1.5 1.5 0 0 0-1.5 1.5v.142a1 1 0 0 0-.077-.005H7.795V7.974h.968a1.5 1.5 0 0 0 1.5-1.5V5a1.5 1.5 0 0 0-1.5-1.5zm3.263 1.2H5.5a.3.3 0 0 0-.3.3v1.474a.3.3 0 0 0 .3.3h3.263a.3.3 0 0 0 .3-.3V5a.3.3 0 0 0-.3-.3m5.684 6.263h4.05a.3.3 0 0 1 .3.3v1.474a.3.3 0 0 1-.3.3h-4.05a.3.3 0 0 1-.3-.3v-1.474a.3.3 0 0 1 .3-.3m0 6.263h4.05a.3.3 0 0 1 .3.3V19a.3.3 0 0 1-.3.3h-4.05a.3.3 0 0 1-.3-.3v-1.474a.3.3 0 0 1 .3-.3",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRealtimePipelines);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/realtime-pipelines.079c174d.svg";